import React from 'react'

function NameInput(props) {
  const [name, setName] = React.useState('');
  const [errors, setErrors] = React.useState({});

  function onChange(e) {
    setName(e.target.value);
  }

  function onSubmit(e) {
    e.preventDefault();

    if(name.match(/^[A-zÀ-ú]+$/))
      props.onValid(name);
    else
      setErrors({name: 'Il faut choisir un nom avec des lettres.'});
  };

  React.useEffect(() => {
    document.getElementById('name').focus();
  }, []);

  return <form onSubmit={onSubmit}>
    <div className="mb-3">
      <label htmlFor="name" className="form-label">T'es qui ?</label>
      <div className="input-group has-validation">
        <input type="text" className={"form-control"+(errors.name ? ' is-invalid':'')} value={name} onChange={onChange} id="name"/>
        {errors.name && <div id="validationServerUsernameFeedback" className="invalid-feedback">
          {errors.name}
        </div>}
      </div>
    </div>
    <button type="submit" className="btn btn-primary">Valider</button>
  </form>
}

export default NameInput